import { omit } from 'lodash'
import { type CertificateProgramProduct } from '@mc/api'
import { TrackOnMount } from '../certificatesTracking'

type TrackProductViewedProps = {
  product: CertificateProgramProduct
}

/**
 * Fires the `productViewed` gold standard event for a certificate product.
 *
 * The event's `price` is set from the top-level `nonDiscountedPrice`, which is
 * always the full price. We also drop `price` from the analytics spread, because
 * the BE `analytics.price` is the discounted price when a coupon applies — so
 * this event never reports the discounted amount (MCCERTS-2547).
 */
export const TrackProductViewed = ({ product }: TrackProductViewedProps) => (
  <TrackOnMount
    event='productViewed'
    product_id={product.id}
    currency={product.currency}
    name={product.name}
    price={product.nonDiscountedPrice}
    {...omit(product.analytics, 'product', 'price')}
  />
)
